module.exports = __webpack_public_path__ + "img/key_images.5e99ac9f.png";